module.exports = __webpack_public_path__ + "static/media/close.67f22c57.svg";